/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

class InvalidTransactionError extends Error {
  constructor(message) {
    super(message);
    this.id = String("InvalidTransactionError");
  }
}
export default InvalidTransactionError;
